// extracted by mini-css-extract-plugin
module.exports = {"entering":"transition-slideUp-module--entering--2OLuc","entered":"transition-slideUp-module--entered--dfIfE","exiting":"transition-slideUp-module--exiting--2O3Xf"};